import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Button from "./Button";
import dineroInicio from "../assets/dineroInicio.png";
import bancoInicio from "../assets/bancoInicio.png";
import relojInicio from "../assets/relojInicio.png";
import { useNavigate } from "react-router-dom";

const defaultCards = [
  {
    title: "MisFICs",
    icon: bancoInicio,
    description:
      "Revisa y compara FICs según tu perfil. Compra y gestiona todo aquí. Invierte con respaldo profesional, diversificación y buenos rendimientos.",
    buttonText: "Abrir FIC",
    path: "/personas/misFICs",
  },
  {
    title: "MisCDTs",
    icon: dineroInicio,
    description:
      "Compara CDTs, elige el que más te convenga y ábrelo fácil desde un solo lugar. Aprovecha tasas competitivas y plazos flexibles para hacer crecer tu dinero con seguridad.",
    buttonText: "Abrir CDT",
    path: "/personas/simula-tu-cdt",
  },
  {
    title: "Mipensión",
    icon: relojInicio,
    description:
      "Compara planes pensionales y compra el ideal para tu futuro sin complicaciones. Asegura tu tranquilidad con una opción confiable y hecha para ti.",
    buttonText: "Abrir Pensión",
    path: "/personas/miPension",
  },
];

const CarouselCards = ({ bgColor = "#220365", textColor = "#220365", items }) => {
  const cards = items ?? defaultCards;
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate();

  const scrollToTopAndNavigate = (path) => {
    window.scrollTo({ top: 0, behavior: "instant" });
    navigate(path);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  };

  return (
    <section
      className="flex items-center justify-center py-12 sm:py-16 lg:py-20 w-full overflow-hidden px-4 sm:px-8 lg:px-20"
      style={{ backgroundColor: bgColor }}
    >
      <div className="relative flex items-center gap-6 w-full max-w-6xl">
        <button
          onClick={handlePrev}
          className="text-white text-2xl sm:text-3xl p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-white/60"
          aria-label="Ver tarjeta anterior"
        >
          <FaChevronLeft />
        </button>

        <div className="flex justify-center w-full">
          {cards.map((card, index) => {
            const isActive = index === activeIndex;
            return (
              <div
                key={index}
                className={`flex flex-col items-center text-center rounded-2xl shadow-lg transition-all duration-300 mx-2 sm:mx-4 ${
                  isActive
                    ? "bg-white scale-100 sm:scale-105 lg:scale-125 z-10"
                    : "bg-gray-200 opacity-0 pointer-events-none hidden sm:flex sm:opacity-50 sm:scale-95 lg:mx-6"
                } w-full max-w-md sm:w-80 lg:w-96 py-6 px-4`}
                aria-hidden={!isActive}
              >
                <h2 className="text-2xl sm:text-3xl font-bold" style={{ color: textColor }}>
                  {card.title}
                </h2>
                <img src={card.icon} alt={card.title} className="my-5 w-16 h-16 sm:w-20 sm:h-20 object-contain" />
                <p className="text-sm sm:text-base text-gray-700 pb-5">{card.description}</p>
                <Button
                  text={card.buttonText}
                  color="bg-[#276ae8]"
                  textColor="text-white"
                  paddingX="px-6"
                  paddingY="py-2"
                  fullWidth={false}
                  rounded="rounded-3xl"
                  onClick={
                    card.path
                      ? () => scrollToTopAndNavigate(card.path)
                      : undefined
                  }
                />
              </div>
            );
          })}
        </div>

        <button
          onClick={handleNext}
          className="text-white text-2xl sm:text-3xl p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-white/60"
          aria-label="Ver tarjeta siguiente"
        >
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
};

export default CarouselCards;
